import React, { useEffect, useState } from "react";
import { getData, putData } from "../../../../services/library";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Alert,
  CircularProgress,
} from "@mui/material";
import Notify from "../../../Notify";
import moment from "moment";
import { UrlApi } from "../../../../services/apirest";

function PasaPedidos(props) {
  const [datos, setDatos] = useState(props.rendicion);
  const [disBtn, setDisBtn] = useState(false);
  const [pedidosAnulada, setPedidosAnulada] = useState([]);
  const [rendicionesDisponibles, setRendicionesDisponibles] = useState([]);
  const [rendicionDestino, setRendicionDestino] = useState("");
  const [cargando, setCargando] = useState(false);
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });


  const obtenerPedidosAnulada = () => {
    getData(
      "/envasado_pedidos/xrendicionasig/" + datos.uuid,
      setPedidosAnulada,
    );
  };

  const obtenerRendicionesDisponibles = () => {
    const fechaFormateada = moment(datos.fecha, "DD-MM-YYYY").format(
      "YYYY-MM-DD",
    );

    getData(
      "/envasado_rendiciones/rendicionespasapedidos/" +
        datos.sucursal_chofer +
        "/" +
        fechaFormateada,
      setRendicionesDisponibles,
    );
  };

  useEffect(() => {
    obtenerPedidosAnulada();
    obtenerRendicionesDisponibles();
  }, []);

  const handleClose = () => {
    props.onClose(false);
  };
  // console.log("RENDICIONES DISPONIBLES", rendicionDestino);


const handleConfirmar = async () => {
  if (!rendicionDestino) {
    setNotificacion({
      open: true,
      mensaje: "Por favor, seleccione una rendición destino",
      severity: "warning",
      color: "warning",
    });
    return;
  }

  setDisBtn(true);
  setCargando(true);

  try {
    const ids = pedidosAnulada.map((pedido) => pedido.id);

    const dataToSend = {
      ids: ids,
      data: {
        uuid_rendicion: rendicionDestino,
      },
    };

    const response = await fetch(
      `${UrlApi}/envasado_pedidos/actualizar_multiples`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataToSend),
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      let errorMessage;
      try {
        const errorData = JSON.parse(errorText);
        errorMessage = errorData.error;
      } catch {
        errorMessage = errorText;
      }
      throw new Error(errorMessage || `Error HTTP: ${response.status}`);
    }

    const data = await response.json();

    if (data && data.message === "OK") {
      const { actualizados, total } = data;

      setNotificacion({
        open: true,
        mensaje: `${actualizados} de ${total} pedido(s) pasado(s) exitosamente a la rendición destino`,
        severity: "success",
        color: "success",
      });

      setTimeout(() => {
        props.onClose(true);
      }, 2000);
    } else {
      throw new Error(data?.error || "Error en la respuesta del servidor");
    }
  } catch (error) {
    console.error("Error en handleConfirmar:", error);
    setNotificacion({
      open: true,
      mensaje: "Error al pasar los pedidos: " + (error.message || "Error desconocido"),
      severity: "error",
      color: "error",
    });
  } finally {
    setDisBtn(false);
    setCargando(false);
  }
};

  return (
    <div>
      <Dialog open={props.open} onClose={handleClose} maxWidth="md" fullWidth>
        <Box backgroundColor={"#1F618D"}>
          <DialogTitle>
            <Typography color="#ffffff" fontSize={20}>
              Pasar pedidos de la rendición N° {datos.nro_rendicion}
            </Typography>
          </DialogTitle>
        </Box>

        <DialogContent>
          <Stack spacing={3}>
            {/* Alerta informativa - SIEMPRE VISIBLE */}
            <Alert severity="info" sx={{ flexShrink: 0 }}>
              Se van a pasar {pedidosAnulada.length} pedido(s) a otra rendición
            </Alert>

            {/* Tabla de pedidos con scroll - SOLO ESTA PARTE HACE SCROLL */}
            {pedidosAnulada.length > 0 ? (
              <TableContainer
                component={Paper}
                sx={{
                  maxHeight: 250, // Altura máxima de la tabla
                  overflow: "auto", // Scroll cuando excede la altura
                  flexShrink: 0,
                }}
              >
                <Table size="small" stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}
                      >
                        ID Pedido
                      </TableCell>
                      <TableCell
                        sx={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}
                      >
                        Cliente
                      </TableCell>
                      <TableCell
                        sx={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}
                      >
                        Producto
                      </TableCell>
                      <TableCell
                        sx={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}
                      >
                        Fecha
                      </TableCell>
                      <TableCell
                        sx={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}
                      >
                        Dirección
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {pedidosAnulada.map((pedido) => (
                      <TableRow key={pedido.id}>
                        <TableCell>{pedido.id}</TableCell>
                        <TableCell>{pedido.cliente}</TableCell>
                        <TableCell>{pedido.producto}</TableCell>
                        <TableCell>{pedido.fecha_format}</TableCell>
                        <TableCell>{pedido.direccion_entrega}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Alert severity="warning" sx={{ flexShrink: 0 }}>
                No hay pedidos anulados para pasar
              </Alert>
            )}

            {/* Select de rendición destino - SIEMPRE VISIBLE */}
            {pedidosAnulada.length > 0 && (
              <FormControl fullWidth sx={{ flexShrink: 0, mt: 2 }}>
                <InputLabel id="select-rendicion-label">
                  Seleccionar rendición destino
                </InputLabel>
                <Select
                  labelId="select-rendicion-label"
                  value={rendicionDestino}
                  onChange={(e) => setRendicionDestino(e.target.value)}
                  label="Seleccionar rendición destino"
                  disabled={disBtn}
                >
                  <MenuItem value="">
                    <em>Seleccione una opción</em>
                  </MenuItem>
                  {rendicionesDisponibles
                    .filter((rend) => rend.uuid !== datos.uuid)
                    .map((rendicion) => (
                      <MenuItem key={rendicion.uuid} value={rendicion.uuid}>
                        Rendición N° {rendicion.nro_rendicion} -{" "}
                        {rendicion.nombre_apellido} -{" "}
                        {moment(rendicion.fecha).format("DD-MM-YYYY") ||
                          "Sin fecha"}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            )}
          </Stack>
        </DialogContent>

        <DialogActions>
          <Stack spacing={2} direction="row">
            <Button
              color="error"
              disabled={disBtn}
              variant="contained"
              onClick={handleClose}
            >
              Volver
            </Button>
            <Button
              color="success"
              variant="contained"
              disabled={
                disBtn || pedidosAnulada.length === 0 || !rendicionDestino
              }
              onClick={handleConfirmar}
            >
              Confirmar
            </Button>
          </Stack>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default PasaPedidos;
